import { render, staticRenderFns } from "./ItemShowView.vue?vue&type=template&id=28b8bab8&scoped=true&"
import script from "./ItemShowView.vue?vue&type=script&lang=js&"
export * from "./ItemShowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8bab8",
  null
  
)

export default component.exports